import messages from './cmsArchive.json' with { type: 'json' };

export const cmsArchiveFi: Readonly<typeof messages> = messages;
